module.exports = __webpack_public_path__ + "static/media/18_A.e4c15728.png";